import MedicationInfoCell from "./MedicationInfoCell";

export default MedicationInfoCell;